module.exports = __webpack_public_path__ + "img/planting_02.3d0e7c1.jpg";